/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function HeaderLogo() {
  const classes = useStyles();
  const { data: brandingData } = useSelector((state) => state.branding);
  return (
    <div className={classes.logoWrapper}>
      <img className={classes.logo} src={brandingData.icon} alt="Logo Icon" />
      <Typography className={classes.orgName} variant="h1" component="h1">
        {brandingData.displayName}
      </Typography>
    </div>
  );
}

export default HeaderLogo;
